import styled from "styled-components"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import { useSelector, useDispatch } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { useState } from "react"
import { useEffect } from "react"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive}) => isActive ? theme.mainTextColor : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? theme.mainTextColor : theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);

            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }
`

const InputTrailer = ({data, setData, labelText, name, inputWidth, isRequired, initialOptions, truckType}) => {

  
  const {activeSelect} = useSelector(state => state.layout)

  const [searchText, setSearchText] = useState("")

  useEffect(()=> {
    setSearchText(data?.name)
  },[])

  const dispatch = useDispatch()

  useEffect(() => {
    setSearchText("")
    setData(null)
  }, [truckType])


  const handleOptionClick = (item) => {
    
    setData(item)
    setSearchText(item?.name)
    dispatch(handleActiveSelect(null))

  }

  return (
    <Container onClick={(e)=>e.stopPropagation()} value={searchText} radius={"5px"} isActive={activeSelect === name} inputWidth={inputWidth}>
      <input type="text" id={"text"} onChange={setData} value={searchText} name={"text"} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
      <label htmlFor={"text"}>{labelText}{isRequired && " (Zorunlu)"}</label>
      <MdKeyboardArrowRight className="arr-icon"/>
      {
          activeSelect === name &&
          <div className="options">
              {
                  (initialOptions || [])?.map((item) => (
                      <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                          {item?.name}
                      </div>
                  ))
              }
          </div>
      }
  </Container>
  )
}

export default InputTrailer